module.exports = __webpack_public_path__ + "img/taiwan.4455763e.svg";